<div class="flex flex-row overflow-x-hidden">
<div
  class="w-[67px] xl:w-[80px] 3xl:w-[88px] bg-transparent overflow-x-hidden"
></div>
  <section class="w-[99%] min-h-full bg-gray-50 relative flex justify-center items-center">

    <div
      class="bg-gray-50 border-0 max-w-[1000px] xl:max-w-[1090px] 2xl:max-w-[1340px] mx-auto border-dashed border-gray-200 rounded-2xl pt-0 3xl:pt-1"
    >
    <div
    class="flex flex-col"
    [ngClass]="{
  'mb-[19px]': isEditMode,
  'mb-10 3xl:mb-8': !isEditMode
}"
    >
      <!-- Titolo e pulsanti -->
      <div class="flex w-full justify-between items-center px-7 lg2:px-12 xl:px-3 ">
      <div class="flex flex-col gap-[1px]">
        <h1 class="text-[#0A768A] text-[0.7rem] xl:text-[0.8rem] 2xl:text-[0.9rem] 3xl:text-[1rem] 4xl:text-[1.rem]">
          {{medicineName}}</h1>
        <h2 class="text-[1rem] xl:text-[1.2rem] 2xl:text-2xl text-dimot-1">
          Dashboard Nazionale
          <!-- used for debug {{medicineId}} -->
        </h2>
        </div>
        <div class="flex flex-row gap-3 mt-5" *ngIf="selectedWidgets.length">
          <button
           *ngIf="!isEditMode"
            class="w-[140px] h-[30px] 2xl:w-[180px] 2xl:h-[40px] text-[0.5rem] 2xl:text-[0.65rem] rounded-lg border border-dimot-secondary bg-[#0A778A] hover:bg-[#0D9CB5] flex flex-row justify-center gap-2 items-center cursor-pointer"
            (click)="handleModalChange(true)"
          >
            <span class="text-white">Genera Report Nazionale</span>
                    <svg width="13" height="13" 
         class="relative bottom-[1px] w-[13px] h-[13px] 2xl:w-[16px] 2xl:h-[16px] 3xl:w-[17px] 3xl:h-[17px]"
        viewBox="0 0 16 16" stroke-width="4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.875 9V13C13.875 13.0995 13.8355 13.1948 13.7652 13.2652C13.6948 13.3355 13.5995 13.375 13.5 13.375H2.5C2.40054 13.375 2.30516 13.3355 2.23483 13.2652C2.16451 13.1948 2.125 13.0995 2.125 13V9C2.125 8.90054 2.16451 8.80516 2.23483 8.73483C2.30516 8.66451 2.40054 8.625 2.5 8.625C2.59946 8.625 2.69484 8.66451 2.76517 8.73483C2.83549 8.80516 2.875 8.90054 2.875 9V12.625H13.125V9C13.125 8.90054 13.1645 8.80516 13.2348 8.73483C13.3052 8.66451 13.4005 8.625 13.5 8.625C13.5995 8.625 13.6948 8.66451 13.7652 8.73483C13.8355 8.80516 13.875 8.90054 13.875 9ZM7.735 9.265C7.80531 9.33523 7.90062 9.37467 8 9.37467C8.09938 9.37467 8.19469 9.33523 8.265 9.265L10.765 6.765C10.8312 6.69391 10.8673 6.59989 10.8656 6.50274C10.8639 6.40559 10.8245 6.3129 10.7558 6.24419C10.6871 6.17548 10.5944 6.13613 10.4973 6.13441C10.4001 6.1327 10.3061 6.16876 10.235 6.235L8.375 8.09437V2C8.375 1.90054 8.33549 1.80516 8.26517 1.73483C8.19484 1.66451 8.09946 1.625 8 1.625C7.90054 1.625 7.80516 1.66451 7.73484 1.73483C7.66451 1.80516 7.625 1.90054 7.625 2V8.09437L5.765 6.235C5.69391 6.16876 5.59989 6.1327 5.50274 6.13441C5.40559 6.13613 5.3129 6.17548 5.24419 6.24419C5.17548 6.3129 5.13613 6.40559 5.13441 6.50274C5.1327 6.59989 5.16876 6.69391 5.235 6.765L7.735 9.265Z" fill="white"/>
</svg>

          </button>
          <button
            *ngIf="isEditMode"
            type="button"
            (click)="openAddWidgets()"
            class="group py-2.5 rounded-lg border-1 border-dimot-1 bg-dimot-1 hover:bg-white text-white hover:text-dimot-1 w-[110px] h-[30px] 2xl:w-[150px] 2xl:h-[40px] text-[0.5rem] 2xl:text-[0.65rem] flex flex-row justify-center gap-2 items-center cursor-pointer"
          >
            <span>Aggiungi Widget</span>
            <!-- Default SVG -->
            <svg
              width="14"
              height="14"
              class="block group-hover:hidden"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 1.625C6.73915 1.625 5.50661 1.99889 4.45824 2.69938C3.40988 3.39988 2.59278 4.39551 2.11027 5.56039C1.62776 6.72527 1.50152 8.00707 1.7475 9.2437C1.99348 10.4803 2.60064 11.6162 3.4922 12.5078C4.38376 13.3994 5.51967 14.0065 6.7563 14.2525C7.99293 14.4985 9.27473 14.3722 10.4396 13.8897C11.6045 13.4072 12.6001 12.5901 13.3006 11.5418C14.0011 10.4934 14.375 9.26086 14.375 8C14.373 6.30985 13.7007 4.6895 12.5056 3.49439C11.3105 2.29927 9.69015 1.62698 8 1.625ZM8 13.625C6.88748 13.625 5.79995 13.2951 4.87492 12.677C3.94989 12.0589 3.22892 11.1804 2.80318 10.1526C2.37744 9.12476 2.26604 7.99376 2.48309 6.90262C2.70013 5.81147 3.23586 4.80919 4.02253 4.02252C4.8092 3.23585 5.81148 2.70012 6.90262 2.48308C7.99376 2.26604 9.12476 2.37743 10.1526 2.80318C11.1804 3.22892 12.0589 3.94989 12.677 4.87492C13.2951 5.79994 13.625 6.88748 13.625 8C13.6233 9.49134 13.0302 10.9211 11.9757 11.9756C10.9211 13.0302 9.49134 13.6233 8 13.625ZM10.875 8C10.875 8.09946 10.8355 8.19484 10.7652 8.26517C10.6948 8.33549 10.5995 8.375 10.5 8.375H8.375V10.5C8.375 10.5995 8.33549 10.6948 8.26517 10.7652C8.19484 10.8355 8.09946 10.875 8 10.875C7.90055 10.875 7.80516 10.8355 7.73484 10.7652C7.66451 10.6948 7.625 10.5995 7.625 10.5V8.375H5.5C5.40055 8.375 5.30516 8.33549 5.23484 8.26517C5.16451 8.19484 5.125 8.09946 5.125 8C5.125 7.90054 5.16451 7.80516 5.23484 7.73484C5.30516 7.66451 5.40055 7.625 5.5 7.625H7.625V5.5C7.625 5.40054 7.66451 5.30516 7.73484 5.23484C7.80516 5.16451 7.90055 5.125 8 5.125C8.09946 5.125 8.19484 5.16451 8.26517 5.23484C8.33549 5.30516 8.375 5.40054 8.375 5.5V7.625H10.5C10.5995 7.625 10.6948 7.66451 10.7652 7.73484C10.8355 7.80516 10.875 7.90054 10.875 8Z"
                fill="white"
              />
            </svg>

            <svg
              width="16"
              height="16"
              class="hidden group-hover:block"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="16" height="16" fill="white" />
              <path
                d="M8 1.625C6.73915 1.625 5.50661 1.99889 4.45824 2.69938C3.40988 3.39988 2.59278 4.39551 2.11027 5.56039C1.62776 6.72527 1.50152 8.00707 1.7475 9.2437C1.99348 10.4803 2.60064 11.6162 3.4922 12.5078C4.38376 13.3994 5.51967 14.0065 6.7563 14.2525C7.99293 14.4985 9.27473 14.3722 10.4396 13.8897C11.6045 13.4072 12.6001 12.5901 13.3006 11.5418C14.0011 10.4934 14.375 9.26086 14.375 8C14.373 6.30985 13.7007 4.6895 12.5056 3.49439C11.3105 2.29927 9.69015 1.62698 8 1.625ZM8 13.625C6.88748 13.625 5.79995 13.2951 4.87492 12.677C3.94989 12.0589 3.22892 11.1804 2.80318 10.1526C2.37744 9.12476 2.26604 7.99376 2.48309 6.90262C2.70013 5.81147 3.23586 4.80919 4.02253 4.02252C4.8092 3.23585 5.81148 2.70012 6.90262 2.48308C7.99376 2.26604 9.12476 2.37743 10.1526 2.80318C11.1804 3.22892 12.0589 3.94989 12.677 4.87492C13.2951 5.79994 13.625 6.88748 13.625 8C13.6233 9.49134 13.0302 10.9211 11.9757 11.9756C10.9211 13.0302 9.49134 13.6233 8 13.625ZM10.875 8C10.875 8.09946 10.8355 8.19484 10.7652 8.26517C10.6948 8.33549 10.5995 8.375 10.5 8.375H8.375V10.5C8.375 10.5995 8.33549 10.6948 8.26517 10.7652C8.19484 10.8355 8.09946 10.875 8 10.875C7.90055 10.875 7.80516 10.8355 7.73484 10.7652C7.66451 10.6948 7.625 10.5995 7.625 10.5V8.375H5.5C5.40055 8.375 5.30516 8.33549 5.23484 8.26517C5.16451 8.19484 5.125 8.09946 5.125 8C5.125 7.90054 5.16451 7.80516 5.23484 7.73484C5.30516 7.66451 5.40055 7.625 5.5 7.625H7.625V5.5C7.625 5.40054 7.66451 5.30516 7.73484 5.23484C7.80516 5.16451 7.90055 5.125 8 5.125C8.09946 5.125 8.19484 5.16451 8.26517 5.23484C8.33549 5.30516 8.375 5.40054 8.375 5.5V7.625H10.5C10.5995 7.625 10.6948 7.66451 10.7652 7.73484C10.8355 7.80516 10.875 7.90054 10.875 8Z"
                fill="#141F58"
              />
            </svg>
          </button>
          <button
            *ngIf="!isEditMode"
            class="group bg-dimot-1 hover:bg-white text-white hover:text-dimot-1 w-[100px] h-[30px] 2xl:w-[140px] 2xl:h-[40px] text-[0.5rem] 2xl:text-[0.65rem] flex gap-2 justify-center items-center border-1 border-dimot-1 rounded-lg cursor-pointer"
            (click)="toggleEditMode(true)"
          ><span>Modifica layout</span>
            <svg
              width="16"
              height="16"
              class="hidden group-hover:block w-[10px] h-[10px] xl:w-[11px] xl:h-[11px] 2xl:w-[12px] 2xl:h-[12px] 3xl:w-[13px] 3xl:h-[13px] 4xl:w-[14px] 4xl:h-[14px]"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.6484 5.84207L14.157 2.35066C14.0555 2.24909 13.9349 2.16851 13.8022 2.11354C13.6695 2.05857 13.5272 2.03027 13.3836 2.03027C13.24 2.03027 13.0977 2.05857 12.965 2.11354C12.8323 2.16851 12.7117 2.24909 12.6102 2.35066L2.97656 11.985C2.87479 12.0865 2.7941 12.207 2.73912 12.3398C2.68415 12.4725 2.65599 12.6148 2.65625 12.7585V16.2499C2.65625 16.54 2.77149 16.8182 2.9766 17.0233C3.18172 17.2284 3.45992 17.3436 3.75 17.3436H7.24141C7.38508 17.3439 7.52739 17.3157 7.66013 17.2608C7.79288 17.2058 7.91343 17.1251 8.01485 17.0233L17.6484 7.38895C17.75 7.28738 17.8306 7.1668 17.8856 7.03409C17.9405 6.90139 17.9688 6.75915 17.9688 6.61551C17.9688 6.47187 17.9405 6.32963 17.8856 6.19692C17.8306 6.06422 17.75 5.94364 17.6484 5.84207ZM7.35156 16.36C7.3224 16.3894 7.28278 16.406 7.24141 16.4061H3.75C3.70856 16.4061 3.66882 16.3897 3.63952 16.3604C3.61021 16.3311 3.59375 16.2913 3.59375 16.2499V12.7585C3.59393 12.7171 3.6105 12.6775 3.63985 12.6483L10.625 5.66238L14.3367 9.37488L7.35156 16.36ZM16.9852 6.72645L15 8.7116L11.2883 4.99988L13.2734 3.01395C13.288 2.99942 13.3052 2.98789 13.3242 2.98003C13.3431 2.97217 13.3635 2.96812 13.384 2.96812C13.4045 2.96812 13.4249 2.97217 13.4438 2.98003C13.4628 2.98789 13.48 2.99942 13.4945 3.01395L16.9852 6.50535C16.9997 6.51986 17.0112 6.5371 17.0191 6.55606C17.0269 6.57503 17.031 6.59537 17.031 6.6159C17.031 6.63643 17.0269 6.65677 17.0191 6.67573C17.0112 6.6947 16.9997 6.71193 16.9852 6.72645Z"
                fill="#141F58"
              />
            </svg>

            <svg
              width="16"
              height="16"
              class="block group-hover:hidden w-[12px] h-[12px] xl:w-[14px] xl:h-[14px] 2xl:w-[16px] 2xl:h-[16px]"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.6484 5.84207L14.157 2.35066C14.0555 2.24909 13.9349 2.16851 13.8022 2.11354C13.6695 2.05857 13.5272 2.03027 13.3836 2.03027C13.24 2.03027 13.0977 2.05857 12.965 2.11354C12.8323 2.16851 12.7117 2.24909 12.6102 2.35066L2.97656 11.985C2.87479 12.0865 2.7941 12.207 2.73912 12.3398C2.68415 12.4725 2.65599 12.6148 2.65625 12.7585V16.2499C2.65625 16.54 2.77149 16.8182 2.9766 17.0233C3.18172 17.2284 3.45992 17.3436 3.75 17.3436H7.24141C7.38508 17.3439 7.52739 17.3157 7.66013 17.2608C7.79288 17.2058 7.91343 17.1251 8.01485 17.0233L17.6484 7.38895C17.75 7.28738 17.8306 7.1668 17.8856 7.03409C17.9405 6.90139 17.9688 6.75915 17.9688 6.61551C17.9688 6.47187 17.9405 6.32963 17.8856 6.19692C17.8306 6.06422 17.75 5.94364 17.6484 5.84207ZM7.35156 16.36C7.3224 16.3894 7.28278 16.406 7.24141 16.4061H3.75C3.70856 16.4061 3.66882 16.3897 3.63952 16.3604C3.61021 16.3311 3.59375 16.2913 3.59375 16.2499V12.7585C3.59393 12.7171 3.6105 12.6775 3.63985 12.6483L10.625 5.66238L14.3367 9.37488L7.35156 16.36ZM16.9852 6.72645L15 8.7116L11.2883 4.99988L13.2734 3.01395C13.288 2.99942 13.3052 2.98789 13.3242 2.98003C13.3431 2.97217 13.3635 2.96812 13.384 2.96812C13.4045 2.96812 13.4249 2.97217 13.4438 2.98003C13.4628 2.98789 13.48 2.99942 13.4945 3.01395L16.9852 6.50535C16.9997 6.51986 17.0112 6.5371 17.0191 6.55606C17.0269 6.57503 17.031 6.59537 17.031 6.6159C17.031 6.63643 17.0269 6.65677 17.0191 6.67573C17.0112 6.6947 16.9997 6.71193 16.9852 6.72645Z"
                fill="white"
              />
            </svg>
          </button>
          <button
            *ngIf="isEditMode"
            class="group border-1 border-dimot-1 bg-white text-dimot-1 hover:text-white hover:bg-dimot-1 w-[70px] h-[30px] 2xl:w-[90px] 2xl:h-[40px] text-[0.5rem] 2xl:text-[0.65rem] rounded-md flex flex-row justify-center gap-0 items-center cursor-pointer"
            (click)="toggleEditMode(false)"
          >
            <span class="mr-2">Indietro</span>

            <!-- Icona normale -->
             <svg width="16" height="16"
             class="block group-hover:hidden w-[12px] h-[12px] xl:w-[14px] xl:h-[14px] 2xl:w-[16px] 2xl:h-[16px]"
             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.812 12C20.812 12.1492 20.7527 12.2923 20.6473 12.3977C20.5418 12.5032 20.3987 12.5625 20.2495 12.5625H5.10794L10.897 18.3525C10.9523 18.404 10.9966 18.4661 11.0273 18.5351C11.0581 18.6041 11.0746 18.6786 11.0759 18.7541C11.0773 18.8296 11.0634 18.9047 11.0351 18.9747C11.0068 19.0447 10.9647 19.1084 10.9113 19.1618C10.8579 19.2152 10.7942 19.2573 10.7242 19.2856C10.6542 19.3139 10.5791 19.3278 10.5036 19.3264C10.4281 19.3251 10.3536 19.3086 10.2846 19.2778C10.2156 19.2471 10.1535 19.2028 10.102 19.1475L3.352 12.3975C3.24667 12.292 3.1875 12.1491 3.1875 12C3.1875 11.8509 3.24667 11.708 3.352 11.6025L10.102 4.8525C10.2086 4.75314 10.3497 4.69905 10.4954 4.70162C10.6411 4.70419 10.7802 4.76322 10.8832 4.86628C10.9863 4.96934 11.0453 5.10838 11.0479 5.25411C11.0505 5.39983 10.9964 5.54087 10.897 5.6475L5.10794 11.4375H20.2495C20.3987 11.4375 20.5418 11.4968 20.6473 11.6023C20.7527 11.7077 20.812 11.8508 20.812 12Z" fill="#141F58"/>
</svg>
<svg width="16" height="16" 
class="hidden group-hover:block w-[12px] h-[12px] xl:w-[14px] xl:h-[14px] 2xl:w-[16px] 2xl:h-[16px]"
viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.812 12C20.812 12.1492 20.7527 12.2923 20.6473 12.3977C20.5418 12.5032 20.3987 12.5625 20.2495 12.5625H5.10794L10.897 18.3525C10.9523 18.404 10.9966 18.4661 11.0273 18.5351C11.0581 18.6041 11.0746 18.6786 11.0759 18.7541C11.0773 18.8296 11.0634 18.9047 11.0351 18.9747C11.0068 19.0447 10.9647 19.1084 10.9113 19.1618C10.8579 19.2152 10.7942 19.2573 10.7242 19.2856C10.6542 19.3139 10.5791 19.3278 10.5036 19.3264C10.4281 19.3251 10.3536 19.3086 10.2846 19.2778C10.2156 19.2471 10.1535 19.2028 10.102 19.1475L3.352 12.3975C3.24667 12.292 3.1875 12.1491 3.1875 12C3.1875 11.8509 3.24667 11.708 3.352 11.6025L10.102 4.8525C10.2086 4.75314 10.3497 4.69905 10.4954 4.70162C10.6411 4.70419 10.7802 4.76322 10.8832 4.86628C10.9863 4.96934 11.0453 5.10838 11.0479 5.25411C11.0505 5.39983 10.9964 5.54087 10.897 5.6475L5.10794 11.4375H20.2495C20.3987 11.4375 20.5418 11.4968 20.6473 11.6023C20.7527 11.7077 20.812 11.8508 20.812 12Z" fill="white"/>
</svg>


           <!-- <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="block group-hover:hidden"
            >
              <path
                d="M8 17L3 12M3 12L8 7M3 12H21"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>-->

            <!-- Icona su hover -->
          <!--  <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="hidden group-hover:block"
            >
              <path
                d="M8 17L3 12M3 12L8 7M3 12H21"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg> -->
          </button>
        </div>
      </div>
    </div>
          <span 
          class="relative bottom-5 w-full block text-start pl-[29px] lg2:px-12 xl:pl-3  text-dimot-1 text-[0.6rem] xl:text-[0.7rem] 2xl:text-[0.9rem] 3xl:text-[1rem]"
          *ngIf="isEditMode">*Stai modificando solo la visualizzazione: i widget vengono aggiunti, spostati o nascosti, non eliminati definitivamente.</span>

    <!-- IF NO WIDGET -->
    <div *ngIf="!selectedWidgets.length" class="w-full items-center">
      <img
        src="../../../../../assets/img/AggiungiWidget.png"
        width="320"
        class="cursor-pointer"
        (click)="openAddWidgets()"
      />
    </div>


      <div
        cdkDropList
        [cdkDropListData]="selectedWidgets"
        cdkDropListOrientation="mixed"
        (cdkDropListDropped)="drop($event)"
        class="flex flex-wrap w-full gap-[23px] 2xl:gap-[30px] items-center justify-center overflow-visible h-full"
      >
        <div
          *ngFor="let widget of selectedWidgets"
          cdkDrag
          [cdkDragDisabled]="!isEditMode"
          class="relative"
        >
          <!-- Handle -->
      <div
  cdkDragHandle
  *ngIf="isEditMode"
  class="absolute top-2 left-1 transform -translate-x-0/2 w-10 h-10 flex items-center justify-center cursor-move select-none"
>
            <svg
              width="18px"
              height="18px"
              class="w-[16px] h-[16px] xl:w-[18px] xl:h-[18px]"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              stroke="#b0b0b0"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M8 6.5C9.38071 6.5 10.5 5.38071 10.5 4C10.5 2.61929 9.38071 1.5 8 1.5C6.61929 1.5 5.5 2.61929 5.5 4C5.5 5.38071 6.61929 6.5 8 6.5Z"
                  fill="#b0b0b0"
                ></path>
                <path
                  d="M15.5 6.5C16.8807 6.5 18 5.38071 18 4C18 2.61929 16.8807 1.5 15.5 1.5C14.1193 1.5 13 2.61929 13 4C13 5.38071 14.1193 6.5 15.5 6.5Z"
                  fill="#b0b0b0"
                ></path>
                <path
                  d="M10.5 12C10.5 13.3807 9.38071 14.5 8 14.5C6.61929 14.5 5.5 13.3807 5.5 12C5.5 10.6193 6.61929 9.5 8 9.5C9.38071 9.5 10.5 10.6193 10.5 12Z"
                  fill="#b0b0b0"
                ></path>
                <path
                  d="M15.5 14.5C16.8807 14.5 18 13.3807 18 12C18 10.6193 16.8807 9.5 15.5 9.5C14.1193 9.5 13 10.6193 13 12C13 13.3807 14.1193 14.5 15.5 14.5Z"
                  fill="#b0b0b0"
                ></path>
                <path
                  d="M10.5 20C10.5 21.3807 9.38071 22.5 8 22.5C6.61929 22.5 5.5 21.3807 5.5 20C5.5 18.6193 6.61929 17.5 8 17.5C9.38071 17.5 10.5 18.6193 10.5 20Z"
                  fill="#b0b0b0"
                ></path>
                <path
                  d="M15.5 22.5C16.8807 22.5 18 21.3807 18 20C18 18.6193 16.8807 17.5 15.5 17.5C14.1193 17.5 13 18.6193 13 20C13 21.3807 14.1193 22.5 15.5 22.5Z"
                  fill="#b0b0b0"
                ></path>
              </g>
            </svg>
          </div>

          <app-card-widget
            [title]="widget.name"
            [className]="widget.className"
            [isEdit]="isEditMode"
            [widgetId]="widget.id"
            [extendWidget]="widget.goLarge"
            (openModalAddActivities)="handleModalActivitiesToggle($event)"
            (deleteWidget)="onDeleteWidget($event)"
            (openAccessCurve)="onOpenAccessCurveFromWidget($event)"
            (openMarketCurve)="onOpenMarketCurveFromWidget($event)"
            class="inline-block h-full"
          >
          </app-card-widget>
        </div>
      </div>
    </div>

    <div *ngIf="isAddWidgetsOpen">
      <app-add-widgets
        (widgetsUpdated)="onWidgetsUpdated($event)"
        (addWidgetsModalOpen)="openModalAddWidgetsFromChild($event)"
      ></app-add-widgets>
    </div>
  </section>
</div>
  <app-modal-activities-selection
    *ngIf="isModalActivitiesOpen"
    (openModalActivities)="handleModalActivitiesToggle($event)"
  ></app-modal-activities-selection>

  <app-generate-national-report
    *ngIf="isGenerateNationalPPTModuleOpen"
    (isModalOpen)="handleModalChange($event)"
    [medicineInfoData]="medicineInfo"
  >
  </app-generate-national-report>

